<template>
  <b-container>
    <b-row>
      <b-col class='bold-gold'>
        {{ warning  }}
      </b-col>
    </b-row>
    <b-row id="vendor-row">
      <b-col sm="2">
        <label for="vendorId">Vendor name</label>
      </b-col>
      <b-col sm="8">
        <v-select v-model="selectedVendor"
                  id="vendorId"
                  placeholder="Select vendor please. Minimum 3 chars."
                  :options="vendors"
                  :filterable="false"
                  @search="onSearch"
                  @input="applySelectedVendor">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.label }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.label }}
            </div>
          </template>
        </v-select>
      </b-col>
    </b-row>
    <b-row id="product-row">
      <b-col sm="2">
        <label for="productId">Product name</label>
      </b-col>
      <b-col sm="8">
        <v-select v-model="selectedProduct"
                  id="productId"
                  placeholder="Please choose product"
                  class="mb-3"
                  :options="productsForVendor"
                  :disabled="selectedVendor == null"
                  @input="applyProductId">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.label }}
            </div>
          </template>
        </v-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VendorProductSearchMixin from '@/mixins/VendorProductSearchMixin'

export default {
  name: 'VendorProductSearch',
  mixins: [VendorProductSearchMixin],
  methods: {
    applySelectedVendor: function (selectedVendor) {
      return new Promise((resolve) => {
        if (selectedVendor !== null) {
          this.refreshProducts(selectedVendor)
        }
        this.selectedProduct = null
        resolve(selectedVendor)
        this.$emit('applyVendorId',
          selectedVendor ? selectedVendor.id : null
        )
      })
    },
    applyProductId: function (productValue) {
      this.$emit('applyProductId',
        productValue ? productValue.id : null
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .v-select {
    font-family: 'Avenir', Helvetica, Arial, sans-serif
  }

  .bold-gold {
    color: #E8AF2E;
    font-weight: bold;
  }

  .b-card-space {
    margin-bottom: 10px;
    margin-top: 10px;
  }

  #product-row { margin-top: 10px }
</style>
